module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/sSj6S5/tc-custom/9781429922678.jpg?1737768256230",
      "alt": "This image is the cover for the book Robert The Bruce, The Guardians"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Robert The Bruce, The Guardians\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The acclaimed author of "), _c('i', [_vm._v("The Forest Laird")]), _vm._v(" delivers “a bold, brash tribute to . . . one of medieval Scotland’s fiercest warriors and its most revered king” ("), _c('i', [_vm._v("Booklist")]), _vm._v(").")]), _c('br'), _c('br'), _vm._v("Robert I, or as he is known to a grateful Scottish nation, Robert the Bruce, was one of Scotland’s greatest kings, as well as one of the most famous warriors of his generation. He led the valiant Scots in the Wars of Scottish Independence against the Kingdom of England. His reign saw the recognition of Scotland as an independent nation, and today Bruce is remembered as a national hero. In this vividly detailed biographical novel, Jack Whyte brings this legend of history to gritty, passionate life."), _c('br'), _c('br'), _vm._v("In the late thirteenth century, Robert and his father joined the rebellion against John Balliol, England’s appointed king of Scotland. Thus began his decades-long fight for Scottish freedom. He was a tireless campaigner in both battle and diplomacy. Finally, in May of 1328, King Edward III signed the Treaty of Edinburgh-Northampton, which recognized Scotland as an independent kingdom and Bruce as its king.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jack Whyte\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    A Tom Doherty Associates Book\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0